import React from "react";
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { FilterYearType } from "../common/ReportFilters";
import DropdownReport from "../../report.dropdwn";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelHeight } from "../../functions/Report.ExportHeight";
import { formatDataHeight } from "../../utils/Report.Format";
import { BARCHART, STYLEBODY } from "../../../../utils/useStyle";

const ReportHeight = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = React.useState({
    label: "-",
    value: "NONE",
  });
  const [height, setHight] = React.useState({
    label: "-",
    value: "level0",
  });

  const [data, setData] = React.useState({
    lt_deep1: 0,
    lt_deep2: 0,
    lt_deep3: 0,
    lt_deep4: 0,
    lt_deep5: 0,
    lt_deep6: 0,
    lt_deep7: 0,
    lt_deep8: 0,
    lt_deep9: 0,
    lt_deep10: 0,
    lt_deep11: 0,
    lt_deep12: 0,
    //
    rt_deep1: 0,
    rt_deep2: 0,
    rt_deep3: 0,
    rt_deep4: 0,
    rt_deep5: 0,
    rt_deep6: 0,
    rt_deep7: 0,
    rt_deep8: 0,
    rt_deep9: 0,
    rt_deep10: 0,
    rt_deep11: 0,
    rt_deep12: 0,
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getHeightReport({
          year: String(year?.value),
          type: String(type?.value),
          height: String(height?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching height report:", error);
      }
    };
    fetchData();
  }, [year, type, height, userDept]);

  const optionHight = [
    { label: "-", value: "level0" },
    { label: "น้อยกว่า 100", value: "level1" },
    { label: "100 - 120", value: "level2" },
    { label: "121 - 140", value: "level3" },
    { label: "141 - 160", value: "level4" },
    { label: "161 - 180", value: "level5" },
    { label: "181 - 200", value: "level6" },
    { label: "มากกว่า 200", value: "level7" },
  ];

  const listTable = [
    { name: "0-5 ", left: data?.lt_deep1, right: data?.rt_deep1 },
    { name: "6-10", left: data?.lt_deep2, right: data?.rt_deep2 },
    { name: "11-15", left: data?.lt_deep3, right: data?.rt_deep3 },
    { name: "16-20", left: data?.lt_deep4, right: data?.rt_deep4 },
    { name: "21-25", left: data?.lt_deep5, right: data?.rt_deep5 },
    { name: "26-30", left: data?.lt_deep6, right: data?.rt_deep6 },
    { name: "31-35", left: data?.lt_deep7, right: data?.rt_deep7 },
    { name: "36-40", left: data?.lt_deep8, right: data?.rt_deep8 },
    { name: "41-45", left: data?.lt_deep9, right: data?.rt_deep9 },
    { name: "46-50", left: data?.lt_deep10, right: data?.rt_deep10 },
    { name: "51-55", left: data?.lt_deep11, right: data?.rt_deep11 },
    { name: "56-60", left: data?.lt_deep12, right: data?.rt_deep12 },
  ];

  return (
    <div>
      _____________________________________________________________________________________
      <div className={``}>
        <div className="my-20">
          <>
            <div className="flex flex-col gap-4">
              <div className="text-black text-lg font-medium">
                รายงานความสูง ความลึก(ซ.ม.) และข้างที่ใส่สาย (ซ้าย,ขวา)
                <div className={STYLEBODY}>
                  เลือกตามความสูง
                  {height.label} ซ.ม. ของปี "{year.label}" ประเภทสาย "
                  {type.label}"
                </div>
              </div>
              <div className="flex justify-center items-end gap-2 my-10">
                <FilterYearType
                  year={year}
                  setYear={setYear}
                  type={type}
                  setType={setType}
                />
                <DropdownReport
                  title={"ส่วนสูง (ซ.ม.)"}
                  className="w-40"
                  options={optionHight}
                  value={height}
                  setValue={setHight}
                />
                <ButtonExcel
                  onClick={() => {
                    ExcelHeight(
                      formatDataHeight(data),
                      year,
                      type,
                      setLoading,
                      height
                    );
                  }}
                  loading={loading}
                />
              </div>
            </div>

            <div className={BARCHART}>
              <BarChart
                width={750}
                height={300}
                data={listTable}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <YAxis />
                <Tooltip />
                <Bar
                  label={{ fill: "#111827" }}
                  dataKey="left"
                  fill="#fecdd3"
                />
                <Bar
                  label={{ fill: "#111827" }}
                  dataKey="right"
                  fill="#f9a8d4"
                />
              </BarChart>
            </div>
            <div className="grid grid-cols-12  ml-12 mr-4 my-4 text-sm">
              <div className=" -rotate-45 transform-gpu text-center">0-5</div>
              <div className=" -rotate-45 transform-gpu text-center">6-10</div>
              <div className=" -rotate-45 transform-gpu text-center">11-15</div>
              <div className=" -rotate-45 transform-gpu text-center">16-20</div>
              <div className=" -rotate-45 transform-gpu text-center">21-25</div>
              <div className=" -rotate-45 transform-gpu text-center">26-30</div>
              <div className=" -rotate-45 transform-gpu text-center">31-35</div>
              <div className=" -rotate-45 transform-gpu text-center">36-40</div>
              <div className=" -rotate-45 transform-gpu text-center">41-45</div>
              <div className=" -rotate-45 transform-gpu text-center">46-50</div>
              <div className=" -rotate-45 transform-gpu text-center">51-55</div>
              <div className=" -rotate-45 transform-gpu text-center">56-60</div>
            </div>
            <div className="flex justify-center">
              <div className="flex items-center">
                <div
                  className="box-content h-3 w-4"
                  style={{ backgroundColor: "#fecdd3" }}
                ></div>
                <div className="mx-2" style={{ color: "#fecdd3" }}>
                  left
                </div>
              </div>
              <div className="flex items-center">
                <div
                  className="box-content h-3 w-4"
                  style={{ backgroundColor: "#f9a8d4" }}
                ></div>
                <div className="mx-2" style={{ color: "#f9a8d4" }}>
                  right
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReportHeight;
